var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_11563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.4C0 2.38776 2.38777 0 6.4 0H20.8C26.9856 0 32 5.0144 32 11.2V25.6C32 29.6122 29.6122 32 25.6 32H11.2C5.0144 32 0 26.9856 0 20.8V6.4Z",
    fill: "url(#paint0_linear_234_11563)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.495 22.214C25.0617 23.5087 23.7075 24.2639 22.4075 23.8323C21.1076 23.4008 20.3492 22.0521 20.7826 20.7574C21.2159 19.4627 22.57 18.7074 23.87 19.139C25.17 19.5166 25.8742 20.8653 25.495 22.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9558 9.47733L11.2424 17.8903C10.8083 19.1367 9.45155 19.8637 8.14912 19.4483C6.84669 19.0328 6.08692 17.7345 6.52109 16.4881L9.2345 8.07516C9.66864 6.82879 11.0253 6.10175 12.3278 6.5172C13.6302 6.88072 14.39 8.17903 13.9558 9.47733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4582 15.5125L16.7376 23.9255C16.3023 25.1719 14.942 25.899 13.6362 25.4835C12.3303 25.068 11.5685 23.7697 12.0038 22.5234L14.7244 14.1104C15.1597 12.864 16.52 12.137 17.8258 12.5524C19.1317 12.9159 19.839 14.2142 19.4582 15.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05326 19.5668C8.89278 19.5668 8.73233 19.5668 8.57185 19.5144C7.93002 19.3048 7.55559 18.6238 7.76954 17.9952C7.93002 17.4714 8.46487 17.1571 8.99975 17.1571C9.53463 16.9475 10.9788 15.8998 11.9415 15.1664C14.9368 12.9663 16.1861 12.2846 17.3628 12.4942C18.0581 12.5989 18.486 13.2276 18.379 13.9086C18.272 14.5372 17.6837 14.9563 17.0953 14.9039C16.4535 15.0611 14.6159 16.2141 13.4392 17.1047C11.1392 18.781 9.96254 19.5668 9.05326 19.5668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_234_11563",
    x1: 1.44,
    y1: 2.4,
    x2: 59.04,
    y2: 62.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6DA25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_11563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.2f9a57e3118862136c2640eaa27ead41.svg";
export { ForwardRef as ReactComponent };